import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <div className="fixed bottom-4 right-4 z-50 flex items-center gap-3" data-id="element-289">
      <div className="bg-white text-black text-xs font-bold py-2 px-3 rounded-2xl shadow-lg relative hidden sm:block" data-id="element-290">
        ¿Tenés dudas? Escribinos por WhatsApp
        <div className="absolute top-1/2 -right-2 -translate-y-1/2 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-white" data-id="element-291"></div>
      </div>
      <motion.a href="https://wa.me/+5493813588908" target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} className="bg-[#25D366] text-white p-3 md:p-4 rounded-full shadow-[0_0_15px_rgba(37,211,102,0.5)] flex items-center justify-center" data-id="element-292">
        <MessageCircle size={28} className="md:w-8 md:h-8" data-id="element-293" />
      </motion.a>
    </div>;
}